<template>
    <div
        class="
            d-flex
            flex-column
        "
        :style="{
            height: heightStyle
        }"
    >

        <!-- Text -->
        <div
            class="
                d-flex
                flex-column
                flex-grow-1
            "
            :class="[
                textPositionClasses,
                {
                    'order-2': modelValue.mediaSide === 'top',
                    'order-1': modelValue.mediaSide === 'bottom'
                }
            ]"
        >
            <div
                class="
                    fit-height
                    w-100
                    w-md-50

                    pt-md-0
                    pt-8
                    pb-2
                    px-2
                "
                :class="[
                    textAlignClass
                ]"
            >
                <h2
                    class="
                        text-headline-large
                        content-block-text-title
                        font-weight-bold
                        text-uppercase
                        pa-0
                        ma-0
                    "
                >
                    {{ modelValue.heading }}
                </h2>
                <div>
                    {{ modelValue.body }}
                </div>
            </div>

        </div>

        <!-- Media -->
        <div
            class="
                d-flex
                flex-column
            "
            :class="{
                'order-1': modelValue.mediaSide === 'top',
                'order-2': modelValue.mediaSide === 'bottom'
            }"
        >
            <template
                v-if="modelValue.altImage && modelValue.image"
            >
                <FullImage
                    v-if="isMobile"
                    :image-object="modelValue.altImage"
                    :type="isMobile ? 'medium' : 'large'"
                    scalable
                />
                <FullImage
                    v-else
                    :image-object="modelValue.image"
                    :type="isMobile ? 'medium' : 'large'"
                    scalable
                />
            </template>
            <template
                v-else-if="modelValue.image"
            >
                <FullImage
                    :image-object="modelValue.image"
                    :type="isMobile ? 'medium' : 'large'"
                    scalable
                />
            </template>
            <template
                v-else-if="modelValue.videoSm && isMobile"
            >
                <BlockTypeVideoStatic
                    :model-value="modelValue.videoSm"
                />
            </template>
            <template
                v-else-if="modelValue.videoLg"
            >
                <BlockTypeVideoStatic
                    :model-value="modelValue.videoLg"
                />
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductFeatureYSplitV1
    } from '~/types';
    import {
        useContentBlocksUtils
    } from '~/composables';

    const props = defineProps<{
        modelValue: ProductFeatureYSplitV1['values'];
        isMobile: boolean;
        breakpoint: string;
        breakpointName: string;
    }>();

    const FullImage = defineAsyncComponent(() => import('~/components/media/FullImage/FullImage.vue'));
    const BlockTypeVideoStatic = defineAsyncComponent(() => import('~/components/content/blocks/v2/BlockTypeVideoStatic/BlockTypeVideoStatic.vue'));

    const isMobile = computed(() => props.isMobile);
    const { getBlockHeightStyle, getBlockTextPositionClasses } = useContentBlocksUtils();

    const heightStyle = computed(() => isMobile.value ? 'auto' : getBlockHeightStyle(props.modelValue.height));
    const textPositionClasses = computed(() => getBlockTextPositionClasses(props.modelValue.textPosition));

    const textAlignClass = computed(() => isMobile.value ? 'text-center' : `text-${props.modelValue.textAlign}`);
</script>

<style lang="scss"></style>
